import { render, staticRenderFns } from "./BuyBoxMonitor.vue?vue&type=template&id=53f1daa4&scoped=true"
import script from "./BuyBoxMonitor.vue?vue&type=script&lang=js"
export * from "./BuyBoxMonitor.vue?vue&type=script&lang=js"
import style0 from "./BuyBoxMonitor.vue?vue&type=style&index=0&id=53f1daa4&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./BuyBoxMonitor.vue?vue&type=style&index=2&id=53f1daa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f1daa4",
  null
  
)

export default component.exports